'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _canvasStuff = require('./../../vehicle/vehicleAppraisal/bodywork/canvasStuff');

var _FormValidationService = require('./../../../common/services/FormValidationService');

var _FormValidationService2 = _interopRequireDefault(_FormValidationService);

var _updateConactDpaTemplate = require('./updateConactDpaTemplate.html');

var _updateConactDpaTemplate2 = _interopRequireDefault(_updateConactDpaTemplate);

var _updateContactAllDpaTemplate = require('./updateContactAllDpaTemplate.html');

var _updateContactAllDpaTemplate2 = _interopRequireDefault(_updateContactAllDpaTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnquiryEditController = function () {
  function EnquiryEditController(authService, $stateParams, enums, $scope, loadingService, enquiryService, $state, $timeout, $filter, addPromiseService, $q, $uibModal, contactService, $ngConfirm, integrationService, growl, printService, fileService, adminService, $sce, appConfig, lookupService) {
    "ngInject";

    var _this = this;

    (0, _classCallCheck3.default)(this, EnquiryEditController);
    var permissionToCheck = void 0;
    if ($stateParams.enquiryId) {
      permissionToCheck = enums.PERMISSION_TYPE.Edit;
    } else {
      permissionToCheck = enums.PERMISSION_TYPE.Add;
    }
    if (!authService.validateUser(false, 'Enquiry', permissionToCheck, true)) {
      return;
    }

    this.authService = authService;
    this.$stateParams = $stateParams;
    this.enums = enums;
    this.$scope = $scope;
    this.loadingService = loadingService;
    this.enquiryService = enquiryService;
    this.$state = $state;
    this.$timeout = $timeout;
    this.$filter = $filter;
    this.addPromiseService = addPromiseService;
    this.$q = $q;
    this.$uibModal = $uibModal;
    this.contactService = contactService;
    this.$ngConfirm = $ngConfirm;
    this.integrationService = integrationService;
    this.growl = growl;
    this.printService = printService;
    this.fileService = fileService;
    this.adminService = adminService;
    this.$sce = $sce;
    this.appConfig = appConfig;
    this.lookupService = lookupService;

    this.authService.getLocationExtendedProperties('customForms');
    this.authService.getLocationExtendedProperties('webLeadFollowUpEmail');
    this.authService.getLocationExtendedProperties('makeModelMandatory');

    this.formValidationService = new _FormValidationService2.default();

    this.enquiry = {
      entityId: authService.authData.currentLocation.key,
      enquiryVehicles: [],
      testDrives: [],
      tradeInVehicles: [],
      enquiryPrices: [],
      enquiryPayments: [],
      notes: [],
      enquiryQuotes: [],
      enquiryLostReason: null,
      enquirySourceId: null,
      state: enums.ENQUIRY_STATE.Open,
      isDpaSet: $stateParams.isDpaSet !== null ? $stateParams.isDpaSet : true,
      isAllDpaSet: $stateParams.isAllDpaSet !== null ? $stateParams.isAllDpaSet : true
    };

    this.amountToPay = 0;
    this.balanceDue = 0;

    this.panelNames = ['basicDetails', 'vehicles', 'testDrives', 'tradeIns', 'pricing', 'quotes', 'conclusion', 'notes', 'enquiryTimeline', 'customForms'];

    this.panels = {};

    this.saveAndGoToList = [];
    this.saveAndGoToList.push({ name: 'My Dasboard', state: { name: 'dashboard', params: {} } });
    this.saveAndGoToList.push({ name: 'All Enquiries List', state: { name: 'enquiryList', params: {} } });

    this.initialized = false;
    this.$scope.$on('enquiryPricing:initialized', this.enquiryPricingInitialized.bind(this));
    this.$scope.$on('enquiryPricing:notesUpdated', this.notesUpdated.bind(this));
    this.$scope.$on('enquiryConclude:enquiryConfirmed', this.enquiryConfirmed.bind(this));
    this.$scope.$on('enquiry:proxyEvent', this.proxyEvent.bind(this));

    this.lookupService.lookupBrands().then(function (response) {
      return _this.brands = response;
    });
    this.lookupService.lookupBrandModels().then(function (response) {
      return _this.brandModels = response;
    });

    this.loadEnquiry();
  }

  (0, _createClass3.default)(EnquiryEditController, [{
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
      var objList = [];

      if (defaultOption) {
        objList.push({
          id: null,
          name: 'Please Select'
        });
      }

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'initializeTabs',
    value: function initializeTabs() {
      var _this2 = this;

      this.panelNames.map(function (panelName) {
        _this2.panels[panelName] = {
          visible: true
        };

        if (_this2.$stateParams.activeTab === panelName) {
          _this2.panels[panelName].visible = true;
        } else {
          _this2.panels[panelName].visible = false;
        }

        _this2.updateSummaries(panelName);
      });
    }
  }, {
    key: 'configureForm',
    value: function configureForm() {
      var ctrl = this;

      //Check if selected vehicle belongs to this location
      var ev = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
        return o.isSelected;
      });
      if (ev && ev.vehicle.entityId != this.authService.authData.currentLocation.key) {
        this.otherLocationVehicle = true;
      } else {
        this.otherLocationVehicle = false;
      }

      //Add this to the enquiry so all other sub components can have access to it
      this.enquiry.otherLocationVehicle = this.otherLocationVehicle;

      this.saveAndGoToList.push({ name: ctrl.enquiry.contactName + '\'s Console', state: { name: 'contactView', params: { contactId: ctrl.enquiry.contactId } } });

      ctrl.formValidationService.initialize(ctrl.enquiry);

      //Is Enquiry open
      ctrl.enquiry.isOpen = ctrl.enquiry.state === ctrl.enums.ENQUIRY_STATE.Open;
      //If this is a Multi Vehicle Deal
      ctrl.enquiry.isMultiSelect = ctrl.enquiry.contactType === ctrl.enums.CONTACT_TYPE.Trader;

      this.$scope.$broadcast('enquiry:initialized');

      if (this.$stateParams.code) {
        if (this.$stateParams.action === 'requestSignature') {
          this.requestSignature();
        } else if (this.$stateParams.action === 'viewSignedOrderForm') {
          this.printService.printSignedOrderForm(this.enquiry.enquiryId, this.authService.authData.currentLocation.key, this.$stateParams.code);
        }
      }
    }
  }, {
    key: 'loadEnquiry',
    value: function loadEnquiry() {
      var _this3 = this;

      var ctrl = this;

      if (ctrl.$stateParams.enquiry) {
        /*
        * If there is an enquiry in State Params
        * This means that we left the enquiry edit page to select vehicle / quotation / form etc
        * And we passed the same enquiry object back, which we sent before creating the contact
        * We want to save this enquiry so unsaved changes may not get lost and will cause
        * unwanted results
        */
        (0, _assign2.default)(ctrl.enquiry, ctrl.$stateParams.enquiry);
        ctrl.editEnquiry(null, null, null, true).then(function () {
          ctrl.initializeTabs();
          ctrl.configureForm();
        });
      } else if (ctrl.$stateParams.enquiryId) {
        ctrl.loadingService.showLoading('editEnquiry', 'Loading Enquiry ...');

        ctrl.enquiryService.getEnquiry(ctrl.authService.authData.currentLocation.key, ctrl.$stateParams.enquiryId).then(function (response) {
          (0, _assign2.default)(ctrl.enquiry, response.data);
          _this3.initializeTabs();
          ctrl.configureForm();
        }).catch(function (err) {}).finally(function () {
          ctrl.loadingService.hideLoading('editEnquiry');
        });
      } else {
        /*
        * Its a New Enquiry
        */
        if (!ctrl.$stateParams.contactId || !ctrl.$stateParams.contactName) {
          ctrl.authService.unauthorized('Contact is missing');
        }

        ctrl.enquiry.contactId = ctrl.$stateParams.contactId;
        ctrl.enquiry.contactName = ctrl.$stateParams.contactName;
        ctrl.initializeTabs();
        ctrl.configureForm();
      }
    }
  }, {
    key: 'vehicleSelected',
    value: function vehicleSelected() {
      this.$scope.$broadcast('vehicleSelected');

      var selectedVehicle = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
        return o.isSelected;
      });

      if (!this.enquiry.subject) {
        this.enquiry.subject = selectedVehicle.vehicle.model;
      }

      if (!this.enquiry.amountToSpend) {
        this.enquiry.amountToSpend = selectedVehicle.vehicle.price;
      }
    }
  }, {
    key: 'redirectToParent',
    value: function redirectToParent(goBack) {

      if (this.redirectFromSource()) {
        return;
      }

      if (goBack) {
        this.$state.go('dashboard');
      } else {
        this.$state.go(this.gotoState, this.gotoStateParams);
      }
    }
  }, {
    key: 'redirectFromSource',
    value: function redirectFromSource() {
      if (this.$stateParams.origin) {
        switch (this.$stateParams.origin) {
          case 'editFinance':
            this.$state.go('financeEdit', { financeId: this.enquiry.enquiryId });
            break;
        }

        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'showAddPromise',
    value: function showAddPromise(goBack, state, stateParams) {
      this.goBack = goBack;
      this.gotoState = state, this.gotoStateParams = stateParams, this.addPromiseService.showAddPromise(this.redirectToParent.bind(this), false, null, {
        contactId: this.enquiry.contactId,
        contactName: this.enquiry.contactName
      });
    }
  }, {
    key: 'editEnquiry',
    value: function editEnquiry(goBack, state, stateParams) {
      var _this4 = this,
          _arguments = arguments;

      var isInternalSave = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var isEnquiryConfirmed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      var ctrl = this;
      var deferred = ctrl.$q.defer();
      var enquiryClone = (0, _stringify2.default)(ctrl.enquiry);

      if (this.authService.authData.currentLocation.makeModelMandatory.enabled && !isInternalSave && !ctrl.validateMakeAndModel()) {
        return;
      }

      if (!ctrl.formValidationService.validateForm()) {
        return;
      }

      if (!ctrl.enquiryCloseDpaCheck(isInternalSave, goBack, state, stateParams)) {
        return;
      }

      //Disabled for now ! this may not be needed
      if (!isInternalSave && ctrl.enquiry.state === ctrl.enums.ENQUIRY_STATE.Confirmed && !ctrl.enquiry.isAllDpaSet) {
        //ctrl.showUpdateAllDpa(true, goBack, state, stateParams, isInternalSave);
        //return;
      }

      this.state = 'Saving';

      ctrl.loadingService.showLoading('editEnquiry', 'Saving Changes ...');

      //Remove All Vehicle Objects and just leave their IDs
      var clonedEqVehicles = JSON.parse((0, _stringify2.default)(ctrl.enquiry.enquiryVehicles));
      ctrl.enquiry.enquiryVehicles.map(function (ev) {
        ev.vehicle = null;
      });

      //Remove All Vehicle from Vehicle Trade Ins and just leave their IDs
      var clonedEqTradeIns = JSON.parse((0, _stringify2.default)(ctrl.enquiry.tradeInVehicles));
      ctrl.enquiry.tradeInVehicles.map(function (v) {
        v.vehicle = null;
      });

      //Remove All Enquiry Prices where the amount is 0 (except for complimentary)
      (0, _lodash.remove)(ctrl.enquiry.enquiryPrices, function (o) {
        return !o.complimentary && !o.removed && (o.amount === 0 || o.amount === null);
      });

      if (ctrl.enquiry.criteria) {
        ctrl.enquiry.criteria.brand = null;
        ctrl.enquiry.criteria.brandModel = null;
      }

      ctrl.enquiryService.editEnquiry(ctrl.enquiry).then(function (response) {
        _this4.state = 'Saved';

        ctrl.enquiry.enquiryVehicles = clonedEqVehicles;
        ctrl.enquiry.tradeInVehicles = clonedEqTradeIns;

        if (!isInternalSave) {
          ctrl.showAddPromise(goBack, state, stateParams);
        }

        if (!isEnquiryConfirmed) {
          ctrl.enquiry.isAllDpaSet = response.data.allDpaSet;
          ctrl.enquiry.marketing_Email = response.data.viaEmail;
          ctrl.enquiry.marketing_Post = response.data.viaPost;
          ctrl.enquiry.marketing_Text = response.data.viaText;
          ctrl.enquiry.marketing_Phone = response.data.viaPhone;
        }

        ctrl.enquiry.followUpWebLeadEmail = false;

        deferred.resolve();
      }).catch(function (err) {
        if (err.status === 400) {
          //Bad Request
          ctrl.loadEnquiry();
          ctrl.state = 'ModelError';

          if (err.data.map) {
            err.data.map(function (item) {
              ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
            });
          } else {
            ctrl.formValidationService.addSystemError(null, err.data);
          }
        } else if (err.status === 500) {
          ctrl.state = 'SystemError';
          ctrl.formValidationService.addSystemError(null, 'A system error occurred while processing your request. Please try again later or contact system administrator if problem persists. Error details: ' + err.data.exceptionMessage);
        } else if (err.status === 600) {
          ctrl.warnLinkedEnquiries(err.data, _arguments);
        }
      }).finally(function () {
        ctrl.loadingService.hideLoading('editEnquiry');
      });

      return deferred.promise;
    }
  }, {
    key: 'updateSummaries',
    value: function updateSummaries() {
      var ctrl = this;
      /*
      * It is important to note that when this method will be triggered
      * the visibility control variable defined in this.panels.XXX would
      * not have been updated. This method will fire before the control
      * variable gets updated. Therefore if condition defined in the next
      * block is the inverse of what it should have been.
      */
      (0, _lodash.map)(this.panels, function (panel, panelName) {
        panel.summary = eval('ctrl.updateSummary_' + panelName + '()');
      });
    }
  }, {
    key: 'updateSummary_basicDetails',
    value: function updateSummary_basicDetails() {
      return this.enquiry.contactName;
    }
  }, {
    key: 'updateSummary_vehicles',
    value: function updateSummary_vehicles() {
      var _this5 = this;

      if (this.enquiry.enquiryVehicles.length) {

        var vehicle = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
          return o.isSelected;
        });

        if (!vehicle) {
          vehicle = this.enquiry.enquiryVehicles[this.enquiry.enquiryVehicles.length - 1];
        }

        return vehicle.vehicle.model + ' ' + vehicle.vehicle.variant;
      } else if (this.enquiry.criteria.brandModelId != null) {
        var brand = (0, _lodash.find)(this.brands, function (o) {
          return o.brandId === _this5.enquiry.criteria.brandId;
        });
        var brandModel = (0, _lodash.find)(this.brandModels, function (o) {
          return o.brandModelId === _this5.enquiry.criteria.brandModelId;
        });

        return 'Interested in ' + brand.name + ' ' + brandModel.name;
      }
    }
  }, {
    key: 'updateSummary_testDrives',
    value: function updateSummary_testDrives() {
      if (this.enquiry.testDrives.length) {
        var testDrive = this.enquiry.testDrives[this.enquiry.testDrives.length - 1];
        var formattedDate = '';

        if (testDrive.timeStamp) {
          formattedDate = this.$filter('date')(testDrive.timeStamp, 'dd-MMMM-yyyy');
        }
        return testDrive.model + ', ' + formattedDate;
      }
    }
  }, {
    key: 'updateSummary_tradeIns',
    value: function updateSummary_tradeIns() {
      if (this.enquiry.tradeInVehicles.length) {
        var tradeInVehicle = this.enquiry.tradeInVehicles[this.enquiry.tradeInVehicles.length - 1].vehicle;

        return (tradeInVehicle.brand ? tradeInVehicle.brand : '') + ' ' + tradeInVehicle.model;
      }
    }
  }, {
    key: 'updateSummary_pricing',
    value: function updateSummary_pricing() {
      return 'Amount To Pay: ' + this.$filter('currency')(this.amountToPay, '€', 2) + ', Balance Due: ' + this.$filter('currency')(this.balanceDue, '€', 2);
    }
  }, {
    key: 'updateSummary_quotes',
    value: function updateSummary_quotes() {
      if (this.enquiry.enquiryQuotes.length) {
        var eq = this.enquiry.enquiryQuotes[0];

        var formattedDate = this.$filter('date')(eq.created, 'dd MMM yy HH:mm');

        return 'Last Save Quote On ...' + formattedDate;
      }

      return 'No Quotes Saved';
    }
  }, {
    key: 'updateSummary_conclusion',
    value: function updateSummary_conclusion() {
      switch (this.enquiry.state) {
        case this.enums.ENQUIRY_STATE.Open:
          return 'Status: Open';
          break;

        case this.enums.ENQUIRY_STATE.Lost:
          return 'Status: Lost';
          break;

        case this.enums.ENQUIRY_STATE.Confirmed:
          return 'Status: Confirmed - Awaiting Delivery';
          break;

        case this.enums.ENQUIRY_STATE.Closed:
          return 'Status: Customer Delivered';
          break;
      }
    }
  }, {
    key: 'updateSummary_notes',
    value: function updateSummary_notes() {
      if (this.enquiry.notes.length) {
        var note = this.enquiry.notes[this.enquiry.notes.length - 1];

        return note.text.substring(0, 90);
      }
    }
  }, {
    key: 'updateSummary_enquiryTimeline',
    value: function updateSummary_enquiryTimeline() {}
  }, {
    key: 'updateSummary_customForms',
    value: function updateSummary_customForms() {
      return "";
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      var ctrl = this;
      var retValue = false;

      retValue = ctrl.authService.checkFeatureAccess('Enquiry', ctrl.enums.PERMISSION_TYPE.Edit, false) && (ctrl.authService.isEntityOwner(this.enquiry) || ctrl.authService.isManager());

      /* 
      * Adding a check for Mandatory Make Model 
      * This will return false if makeModelMandatory setting is enabled and there
      * is no makeModelId in the enquiry criteria
      */
      if (this.authService.authData.currentLocation.makeModelMandatory && this.authService.authData.currentLocation.makeModelMandatory.enabled && this.enquiry && this.enquiry.criteria && this.enquiry.enquiryVehicles) {
        retValue = !!(retValue && (this.enquiry.enquiryVehicles.length > 0 || this.enquiry.criteria.brandModelId));
      }

      return retValue;
    }
  }, {
    key: 'canLose',
    value: function canLose() {
      return !this.enquiry.readonly && this.enquiry.enquiryLostReason != null;
    }
  }, {
    key: 'enquiryPricingInitialized',
    value: function enquiryPricingInitialized(e, data) {
      this.initialized = true;
      this.amountToPay = data.amountToPay;
      this.balanceDue = data.balanceDue;

      this.updateSummaries();
    }
  }, {
    key: 'editImage',
    value: function editImage(img) {
      var $container = $('.signature-container');
      var width = $container.width();
      var height = $container.height();

      var $divCanvas = $('<div idx="imageHolder" style="width:' + width + 'px;height:' + height + 'px;background: url(\'\'); background-repeat: no-repeat; background-size: 100% 100%;"><canvas width="' + width + 'px" height="' + height + 'px" id="sig-canvas"></canvas><canvas width="' + width + 'px" height="' + height + 'px" style="display:none;" id="hidden-canvas"></canvas></div>');
      $('.signature-container').empty().append($divCanvas);
      (0, _canvasStuff.doMagic)(null, true);
    }
  }, {
    key: 'showUpdateDpa',
    value: function showUpdateDpa(saveEnquiry, goBack, state, stateParams, isInternalSave) {
      var _this6 = this;

      //debugger;

      var dpa = {
        contactId: this.enquiry.contactId
      };

      if (this.enquiry.enquiryOrigination === this.enums.ENQUIRY_ORIGINATION.Email || this.enquiry.enquiryOrigination === this.enums.ENQUIRY_ORIGINATION.Web) {
        dpa.verbalConsent = true;
      }

      this.$state.go('simpleDpa', { contactId: this.enquiry.contactId, enquiryId: this.enquiry.enquiryId, dpa: dpa });
      return;

      this.$scope.errUpdateDpa = '';
      this.$scope.updateDpa = this.updateDpa.bind(this);
      this.$scope.clearSignature = this.clearSignature.bind(this);
      this.$scope.confirmVerbalConsent = this.confirmVerbalConsent.bind(this);
      this.$scope.checkOptions = this.checkOptionsDpa.bind(this);
      this.$scope.dpa = dpa;

      if (saveEnquiry) {
        this.$scope.saveEnquiry = {
          doSave: true,
          goBack: goBack,
          state: state,
          stateParams: stateParams,
          isInternalSave: isInternalSave
        };
      } else {
        this.$scope.saveEnquiry = {
          doSave: false
        };
      }

      this.$uibModalInstance = this.$uibModal.open({
        template: _updateConactDpaTemplate2.default,
        scope: this.$scope,
        size: 'lg'
      });

      this.$uibModalInstance.opened.then(function () {
        setTimeout(_this6.editImage, 0);
      });
    }
  }, {
    key: 'checkOptionsDpa',
    value: function checkOptionsDpa(val) {
      this.$scope.dpa.viaEmail = val;
      this.$scope.dpa.viaText = val;
      this.$scope.dpa.viaPost = val;
      this.$scope.dpa.viaPhone = val;
    }
  }, {
    key: 'confirmVerbalConsent',
    value: function confirmVerbalConsent() {
      if (this.$scope.dpa.verbalConsent) {
        this.$scope.dpa.verbalConsent = window.confirm('By clicking this checkbox, you will have to sign the DPA on behalf of the customer. Are you sure you want to proceed ?');
      }
    }
  }, {
    key: 'validateDpa',
    value: function validateDpa() {
      this.$scope.errUpdateDpa = '';

      if ((0, _canvasStuff.isCanvasEmpty)()) {
        this.$scope.errUpdateDpa = 'Please sign the form before submitting';
        return false;
      }

      return true;
    }
  }, {
    key: 'updateDpa',
    value: function updateDpa() {
      var _this7 = this;

      var ctrl = this;

      if (!ctrl.validateDpa()) {
        return;
      }

      ctrl.loadingService.showLoading('editEnquiry', 'Updating DPA ...');

      ctrl.$scope.dpa.signData = (0, _canvasStuff.getCanvasData)();
      ctrl.contactService.updateDpa(ctrl.authService.authData.currentLocation.key, ctrl.$scope.dpa).then(function (response) {
        _this7.closeModal();
        _this7.enquiry.isDpaSet = true;
        if (_this7.$scope.saveEnquiry.doSave) {
          _this7.editEnquiry(_this7.$scope.saveEnquiry.goBack, _this7.$scope.saveEnquiry.state, _this7.$scope.saveEnquiry.stateParams, _this7.$scope.saveEnquiry.isInternalSave);
        }
      }).finally(function () {
        ctrl.loadingService.hideLoading('editEnquiry');
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.$uibModalInstance.close();
    }
  }, {
    key: 'showUpdateAllDpa',
    value: function showUpdateAllDpa(saveEnquiry, goBack, state, stateParams, isInternalSave) {
      var _this8 = this;

      var marketing = {
        email: this.enquiry.marketing_Email,
        post: this.enquiry.marketing_Post,
        text: this.enquiry.marketing_Text,
        phone: this.enquiry.marketing_Phone
      };

      this.$state.go('allDpa', { contactId: this.enquiry.contactId, enquiryId: this.enquiry.enquiryId, marketing: marketing });
      return;

      this.$scope.errUpdateDpa = '';
      this.$scope.updateDpa = this.updateAllDpa.bind(this);
      this.$scope.clearSignature = this.clearSignature.bind(this);
      this.$scope.confirmVerbalConsent = this.confirmVerbalConsent.bind(this);
      this.$scope.checkOptions = this.checkOptionsDpaAll.bind(this);

      this.$scope.dpa = {
        contactId: this.enquiry.contactId,
        marketing_Email: this.enquiry.marketing_Email,
        marketing_Post: this.enquiry.marketing_Post,
        marketing_Text: this.enquiry.marketing_Text,
        marketing_Phone: this.enquiry.marketing_Phone
      };

      if (saveEnquiry) {
        this.$scope.saveEnquiry = {
          doSave: true,
          goBack: goBack,
          state: state,
          stateParams: stateParams,
          isInternalSave: isInternalSave
        };
      } else {
        this.$scope.saveEnquiry = {
          doSave: false
        };
      }

      this.$uibModalInstance = this.$uibModal.open({
        template: _updateContactAllDpaTemplate2.default,
        scope: this.$scope,
        size: 'lg'
      });

      this.$uibModalInstance.opened.then(function () {
        setTimeout(_this8.editImage, 0);
      });
    }
  }, {
    key: 'checkOptionsDpaAll',
    value: function checkOptionsDpaAll(val) {
      this.$scope.dpa.marketing_Email = val;
      this.$scope.dpa.marketing_Text = val;
      this.$scope.dpa.marketing_Post = val;
      this.$scope.dpa.marketing_Phone = val;

      this.$scope.dpa.service_Email = val;
      this.$scope.dpa.service_Text = val;
      this.$scope.dpa.service_Post = val;
      this.$scope.dpa.service_Phone = val;

      this.$scope.dpa.manufacturer_Email = val;
      this.$scope.dpa.manufacturer_Text = val;
      this.$scope.dpa.manufacturer_Post = val;
      this.$scope.dpa.manufacturer_Phone = val;

      this.$scope.dpa.surveys_Email = val;
      this.$scope.dpa.surveys_Text = val;
      this.$scope.dpa.surveys_Post = val;
      this.$scope.dpa.surveys_Phone = val;

      this.$scope.dpa.changeCycle_Email = val;
      this.$scope.dpa.changeCycle_Text = val;
      this.$scope.dpa.changeCycle_Post = val;
      this.$scope.dpa.changeCycle_Phone = val;
    }
  }, {
    key: 'updateAllDpa',
    value: function updateAllDpa() {
      var _this9 = this;

      var ctrl = this;

      if (!ctrl.validateDpa()) {
        return;
      }

      ctrl.loadingService.showLoading('editEnquiry', 'Updating DPA ...');

      ctrl.$scope.dpa.signData = (0, _canvasStuff.getCanvasData)();
      ctrl.contactService.updateAllDpa(ctrl.authService.authData.currentLocation.key, ctrl.$scope.dpa).then(function (response) {
        _this9.closeModal();
        _this9.enquiry.isAllDpaSet = true;
        if (_this9.$scope.saveEnquiry.doSave) {
          _this9.editEnquiry(_this9.$scope.saveEnquiry.goBack, _this9.$scope.saveEnquiry.state, _this9.$scope.saveEnquiry.stateParams, _this9.$scope.saveEnquiry.isInternalSave);
        }
      }).finally(function () {
        ctrl.loadingService.hideLoading('editEnquiry');
      });
    }
  }, {
    key: 'clearSignature',
    value: function clearSignature() {
      (0, _canvasStuff.clearCanvas)(true);
    }
  }, {
    key: 'notesUpdated',
    value: function notesUpdated() {
      this.editEnquiry(null, null, null, true);
    }
  }, {
    key: 'confirmRemoveTradeIn',
    value: function confirmRemoveTradeIn() {
      var _this10 = this;

      this.$ngConfirm({
        title: "Warning",
        content: 'Are you sure you want to remove this trade in ?',
        type: 'orange',
        columnClass: 'm',
        buttons: {
          ok: {
            text: 'Yes',
            btnClass: 'btn-primary',
            action: function action() {
              return _this10.removeTradeIn();
            }
          },
          cancel: {
            text: 'Not sure',
            btnClass: 'btn-default',
            action: function action() {}
          }
        }
      });
    }
  }, {
    key: 'removeTradeIn',
    value: function removeTradeIn() {
      var _this11 = this;

      var ctrl = this;
      this.state = 'Saving';

      ctrl.loadingService.showLoading('editEnquiry', 'Removing Trade In ...');

      ctrl.enquiryService.removeTradeIn(this.enquiry.enquiryId).then(function (response) {
        _this11.state = 'Saved';

        _this11.growl.success('Trade In removed successfully', { ttl: 5000 });
        _this11.enquiry.tradeInVehicles = [];
      }).catch(function (err) {
        if (err.status === 500) {
          ctrl.state = 'SystemError';
          ctrl.formValidationService.addSystemError(null, 'Could not remove trade in due to the following error. ' + err.data.exceptionMessage);
        }
      }).finally(function () {
        ctrl.loadingService.hideLoading('editEnquiry');
      });
    }
  }, {
    key: 'enquiryConfirmed',
    value: function enquiryConfirmed() {
      this.editEnquiry(null, null, null, true, true);
    }
  }, {
    key: 'proxyEvent',
    value: function proxyEvent(e, data) {
      this.$scope.$broadcast(data.eventName);
    }
  }, {
    key: 'warnLinkedEnquiries',
    value: function warnLinkedEnquiries(linkedEnquiries, editArgs) {
      var _this12 = this;

      var arrLinkedEnquiries = linkedEnquiries.toString().replace(/\"/g, '').split(',');
      this.$ngConfirm({
        title: 'Multiple Enquiries',
        content: 'There are <b>' + arrLinkedEnquiries.length + '</b> other open enquirie(s) for this Contact with the same trade in vehicle. <br /><br />Confirming this enquiry will mark the other one\'s as lost.</br></br> <b>Are you sure you want to continue ?</b>',
        type: 'orange',
        typeAnimation: false,
        columnClass: 'm',
        buttons: {
          yes: {
            text: 'Yes, Confirm this and Close others',
            btnClass: 'btn-primary',
            action: function action() {
              _this12.enquiryService.closeLinkedEnquiries(arrLinkedEnquiries).then(function () {
                _this12.editEnquiry.apply(_this12, (0, _toConsumableArray3.default)(editArgs));
              });
            }
          },
          no: {
            text: 'No, I will decide later',
            btnClass: 'btn-default',
            action: function action() {
              _this12.$scope.$apply(function () {
                _this12.state = 'Saved';
                _this12.enquiry.state = _this12.enums.ENQUIRY_STATE.Open;
              });
            }
          }
        }
      });
    }
  }, {
    key: 'basicDpaCheck',
    value: function basicDpaCheck() {
      return !this.otherLocationVehicle && this.initialized && !this.enquiry.isDpaSet && this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && this.enquiry.contactType !== this.enums.CONTACT_TYPE.RetailFleet;
    }
  }, {
    key: 'allDpaCheck',
    value: function allDpaCheck() {
      return !this.otherLocationVehicle && this.initialized && (this.enquiry.state === this.enums.ENQUIRY_STATE.Confirmed || this.enquiry.state === this.enums.ENQUIRY_STATE.Closed) && !this.enquiry.isAllDpaSet && this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && this.enquiry.contactType !== this.enums.CONTACT_TYPE.RetailFleet;
    }
  }, {
    key: 'enquiryCloseDpaCheck',
    value: function enquiryCloseDpaCheck(isInternalSave, goBack, state, stateParams) {
      if (isInternalSave || this.enquiry.state != this.enums.ENQUIRY_STATE.Closed) {
        return true;
      }

      //Check for Basic Dpa if its not optinal in the location
      if (!this.authService.authData.currentLocation.basicDpaOptional && !this.enquiry.isDpaSet && this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && this.enquiry.contactType !== this.enums.CONTACT_TYPE.RetailFleet) {
        this.showUpdateDpa(true, goBack, state, stateParams, isInternalSave);
        return false;
      }

      /*if (!isInternalSave && ctrl.enquiry.state === ctrl.enums.ENQUIRY_STATE.Confirmed && !ctrl.enquiry.isDpaSet && ctrl.enquiry.contactType !== ctrl.enums.CONTACT_TYPE.Trader && ctrl.enquiry.contactType !== ctrl.enums.CONTACT_TYPE.RetailFleet) {
        ctrl.showUpdateDpa(true, goBack, state, stateParams, isInternalSave);
        return;
      }*/

      return true;
    }
  }, {
    key: 'requestSignature',
    value: function requestSignature() {
      var _this13 = this;

      this.loadingService.showLoading('editEnquiry', 'Sending request for Signature ...');

      var apiCall = this.integrationService.sendForSignature.bind(this.integrationService);

      if (this.enquiry.contactType === this.enums.CONTACT_TYPE.Trader) {
        apiCall = this.integrationService.sendTradeFormForSignature.bind(this.integrationService);
      }

      apiCall(this.enquiry.entityId, this.enquiry.enquiryId, this.$stateParams.additionalRecipients, this.$stateParams.code, this.enquiry.orderFormVersion).then(function (response) {
        _this13.enquiry.signatureStatus = _this13.enums.SIGNATURE_STATUS.Created;
        _this13.enquiry.signatureState = "Awaiting Customer Signature";

        _this13.growl.success('Signature Request sent successfully', { ttl: 5000 });
      }).catch(function (err) {
        _this13.growl.error('Error sending signature request', { ttl: 5000 });
      }).finally(function () {
        _this13.loadingService.hideLoading('editEnquiry');
      });
    }
  }, {
    key: 'viewSignedOrderForm',
    value: function viewSignedOrderForm() {}
  }, {
    key: 'loadWebLeadFollowUpData',
    value: function loadWebLeadFollowUpData() {
      var _this14 = this;

      var deferred = this.$q.defer();

      if (this.defaultTexts && this.webLeadFollowUpTemplate) {
        deferred.resolve();
        return deferred.promise;
      }

      this.adminService.listDefaultTexts(this.authService.authData.currentLocation.key).then(function (response) {
        _this14.defaultTexts = (0, _lodash.without)(response.data['email'], '');

        _this14.fileService.getWebLeadFollowUpEmailTemplate(_this14.authService.authData.currentLocation.key, _this14.enquiry.enquiryId, _this14.authService.authData.userId).then(function (response) {
          _this14.webLeadFollowUpTemplate = response.data;
          deferred.resolve();
        });
      });

      return deferred.promise;
    }
  }, {
    key: 'showFollowUpEmail',
    value: function showFollowUpEmail() {
      if (!this.enquiry.contactHasEmail) {
        this.$ngConfirm({
          title: 'ERROR',
          content: 'Cannot Send Follow up Email. Contact does not have an email set',
          type: 'red',
          typeAnimation: false,
          columnClass: 'm',
          buttons: {
            tryAgain: {
              text: 'Close',
              btnClass: 'btn-danger'
            }
          }
        });

        return;
      } else {
        this.showFollowUpEmailNext('requestSignature');
      }
    }
  }, {
    key: 'showFollowUpEmailNext',
    value: function showFollowUpEmailNext() {
      var _this15 = this;

      this.loadWebLeadFollowUpData().then(function () {
        _this15.$scope.emailText = null;

        _this15.$scope.selectedText = null;
        _this15.$scope.template = _this15.$sce.trustAsHtml(_this15.webLeadFollowUpTemplate.replace('{{freeText}}', ''));
        _this15.$scope.emailTexts = _this15.defaultTexts;
        _this15.$scope.customLinks = [];
        _this15.$scope.uploadUrl = _this15.appConfig.apiServiceBaseUri + ('api/file/upload/followupimage/' + _this15.enquiry.enquiryId);
        _this15.$scope.imgUrl = _this15.appConfig.apiServiceBaseUri + ('api/file/get/followupimage/' + _this15.enquiry.enquiryId);
        _this15.$scope.images = [];
        _this15.$scope.imagesOverLimit = false;
        _this15.$scope.onMediaUploadSuccess = _this15.onMediaUploadSuccess.bind(_this15);
        _this15.$scope.onMediaUploadError = _this15.onMediaUploadError.bind(_this15);
        _this15.$scope.removeFollowUpImage = _this15.removeFollowUpImage.bind(_this15);

        _this15.$scope.selectEmailText = _this15.selectEmailText.bind(_this15);
        _this15.$scope.updateText = _this15.updateText.bind(_this15);
        _this15.$scope.addCustomLink = _this15.addCustomLink.bind(_this15);
        _this15.$scope.removeLink = _this15.removeLink.bind(_this15);

        _this15.$ngConfirm({
          title: 'Follow Up Email',
          contentUrl: 'templates/enquiry/webLeadFollowUpEmailTemplate',
          typeAnimation: false,
          columnClass: 'xl',
          scope: _this15.$scope,
          buttons: {
            yes: {
              text: 'Send Email',
              btnClass: 'btn-primary',
              action: function action() {
                if (!_this15.updateText() || _this15.$scope.imagesOverLimit) {
                  return false;
                }

                _this15.followUpEmail();
              }
            },
            no: {
              text: 'Leave it',
              btnClass: 'btn-default',
              action: function action() {
                return _this15.removeFollowUpImage();
              }
            }
          }
        });
      });
    }
  }, {
    key: 'selectEmailText',
    value: function selectEmailText(text) {
      this.$scope.selectedText = text;
      this.updateText();
    }
  }, {
    key: 'updateText',
    value: function updateText() {
      var text = this.$scope.selectedText || '';
      text = text.replaceAll('\n', '<br>');

      if (!text) {
        return '';
      }

      var allLinks = (0, _lodash.map)(this.$scope.customLinks, function (item) {
        return '<a href="' + item.link + '" target=_blank>' + item.text + '</a>';
      });
      text += '<br /><br />' + (0, _lodash.join)(allLinks, '<br />');

      var template = this.webLeadFollowUpTemplate.replace('{{freeText}}', text);
      this.$scope.template = this.$sce.trustAsHtml(template);

      return text;
    }
  }, {
    key: 'addCustomLink',
    value: function addCustomLink() {
      if (!this.$scope.tempTextLink) {
        alert('Please enter text for the link');
        return;
      }

      if (!this.$scope.tempLink) {
        alert('Please enter link value');
        return;
      }

      this.$scope.customLinks.push({ text: this.$scope.tempTextLink, link: this.$scope.tempLink });
      this.updateText();
      this.$scope.tempTextLink = null;
      this.$scope.tempLink = null;
    }
  }, {
    key: 'removeLink',
    value: function removeLink(link) {
      this.$scope.customLinks = (0, _lodash.without)(this.$scope.customLinks, link);
      this.updateText();
    }
  }, {
    key: 'followUpEmail',
    value: function followUpEmail() {
      var _this16 = this;

      var data = {
        emailText: this.updateText(),
        entityId: this.authService.authData.currentLocation.key,
        enquiryId: this.enquiry.enquiryId,
        userId: this.authService.authData.userId
      };

      this.enquiryService.sendWebLeadFollowUpEmail(data).then(function (response) {
        _this16.enquiry.followUpWebLeadEmail = false;
        _this16.growl.success('Follow up email sent successfully', { ttl: 5000 });
      });
    }
  }, {
    key: 'onMediaUploadSuccess',
    value: function onMediaUploadSuccess(response) {
      var _this17 = this;

      this.$scope.imagesOverLimit = response.data.item1;
      this.$scope.images = response.data.item2.map(function (imgUrl) {
        return _this17.$scope.imgUrl + '/?fileName=' + imgUrl;
      });
    }
  }, {
    key: 'onMediaUploadError',
    value: function onMediaUploadError(response) {
      alert(response.data[0].value);
    }
  }, {
    key: 'removeFollowUpImage',
    value: function removeFollowUpImage(fileName) {
      var _this18 = this;

      this.fileService.removeFollowUpImage(this.enquiry.enquiryId, fileName).then(function (response) {
        if (response.data.item2 !== null) {
          _this18.$scope.imagesOverLimit = response.data.item1;
          _this18.$scope.images = response.data.item2.map(function (imgUrl) {
            return _this18.$scope.imgUrl + '/?fileName=' + imgUrl;
          });
        }
      });
    }
  }, {
    key: 'noMakeModel',
    value: function noMakeModel() {
      if (this.enquiry && this.enquiry.criteria && this.enquiry.enquiryVehicles) {
        return this.authService.authData.currentLocation.makeModelMandatory.enabled && this.enquiry.enquiryVehicles.length == 0 && !this.enquiry.criteria.brandModelId;
      }
    }
  }, {
    key: 'validateMakeAndModel',
    value: function validateMakeAndModel() {
      if (this.enquiry.enquiryVehicles.length == 0 && !this.enquiry.criteria.brandModelId) {
        this.formValidationService.addModelError("Vehicles", "Please add a Vehicle to this enquiry or specify a search criteria with Make / Model first", false);

        return false;
      }

      return true;
    }
  }]);
  return EnquiryEditController;
}();

exports.default = EnquiryEditController;


// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiryEdit/enquiryEdit.controller.js